import { useState } from 'react';

interface UseNestedFormItemOptions {
    formik: any;
    fieldName: string;
}

export function useNestedFormItem<T>({ formik, fieldName }: UseNestedFormItemOptions) {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const setItem = (item: T) => {
        formik.setFieldValue(fieldName, item);
        setIsOpen(false);
    };

    const removeItem = () => {
        formik.setFieldValue(fieldName, null);
    };

    return {
        isOpen,
        open: () => setIsOpen(true),
        close: () => setIsOpen(false),
        setItem,
        removeItem,
        value: formik.values[fieldName],
        hasError: formik.errors[fieldName]
    };
}
